import _ from "lodash";
import produce from "immer";
import axios from "axios";
import { setAppProcessing, setAppSuccess, setAppError } from "../lib/common";
import strings from "../res/strings";
import { nanoid } from "nanoid";

export const RETRIEVE_LUXURY_ITEM_LISTINGS =
  "luxuryListings/RETRIEVE_LUXURY_ITEM_LISTINGS";
export const CREATE_CONTACT_US_MESSAGE =
  "luxuryListings/CREATE_CONTACT_US_MESSAGE";
export const RETRIEVE_AUTHENTICITY = "luxuryListings/RETRIEVE_AUTHENTICITY";
export const CREATE_CONSIGNMENT_REQUEST =
  "luxuryListings/CREATE_CONSIGNMENT_REQUEST";
export const CREATE_REMOVE_CONSIGNMENT_REQUEST =
  "luxuryListings/CREATE_CONSIGNMENT";
export const RETRIEVE_LUXURY_BRANDS = "luxuryListings/RETRIEVE_LUXURY_BRANDS";
export const CREATE_SERVICE_REQUEST = "luxuryListings/CREATE_SERVICE_REQUEST";

export const ADD_TO_CART = "luxuryListings/ADD_TO_CART";
export const REMOVE_FROM_CART = "luxuryListings/REMOVE_FROM_CART";
export const CREATE_ORDER = "luxuryListings/CREATE_ORDER";
export const RETRIEVE_PAYMENT_METHODS =
  "luxuryListings/RETRIEVE_PAYMENT_METHOD";
export const RETRIEVE_CUSTOMER_ORDERS =
  "luxuryListings/RETRIEVE_CUSTOMER_ORDERS";

export const RETRIEVE_LUXURY_ITEM_LISTING_DETAILS =
  "luxuryListings/RETRIEVE_LUXURY_ITEM_LISTING_DETAILS";

export const CREATE_CERTIFICATE_HARD_COPY_REQUEST =
  "luxuryListings/CREATE_CERTIFICATE_HARD_COPY_REQUEST";

export const SUBMIT_CREDIT_CARD_INFO = "luxuryListings/SUBMIT_CREDIT_CARD_INFO";
export const CREATE_CREDIT_CARD_ORDER =
  "luxuryListings/CREATE_CREDIT_CARD_ORDER";

const RETRIEVE_LUXURY_ITEM_LISTINGS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CREATE_CONTACT_US_MESSAGE_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const RETRIEVE_AUTHENTICITY_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CREATE_CONSIGNMENT_REQUEST_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CREATE_REMOVE_CONSIGNMENT_REQUEST_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const RETRIEVE_LUXURY_BRANDS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CREATE_SERVICE_REQUEST_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CREATE_ORDER_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const RETRIEVE_CUSTOMER_ORDERS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const RETRIEVE_LUXURY_ITEM_LISTING_DETAILS_ERROR = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CREATE_CERTIFICATE_HARD_COPY_REQUEST_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const SUBMIT_CREDIT_CARD_INFO_ERRORS = {
  DEFAUL: {
    error: strings.lib_common_state_error,
  },
};
const CREATE_CREDIT_CARD_ORDER_ERROS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {
  luxuryItemsForSale: [],
  luxuryItemsForSaleResultCount: null,

  luxuryItemsAuthenticated: [],

  luxuryItemsAuthenticatedFrontPage: [],

  luxuryItemsConsigned: [],

  contactUsMessageSent: false,
  contactUsName: null,

  authenticity: {},

  luxuryBrands: [],

  shoppingCart: [],
  cartShortId: null,

  paymentMethods: [],

  customerOrders: [],

  luxuryItemListingDetails: {},

  creditCardPaymentProcessing: false,

  orderSuccessRefNumber: null,
  cartHasService: false,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case RETRIEVE_LUXURY_ITEM_LISTINGS: {
        if (action.mode === "FOR_SALE") {
          draft.luxuryItemsForSaleResultCount = action.resultCount;

          if (action.clearItems) {
            draft.luxuryItemsForSale = [];
          }

          action.luxuryItems.forEach((i) => {
            draft.luxuryItemsForSale.push(i);
          });
        }

        if (action.mode === "MY_AUTHENTICATED_BAGS") {
          draft.luxuryItemsAuthenticated = action.luxuryItems;
        }

        if (action.mode === "MY_CONSIGNMENTS") {
          draft.luxuryItemsConsigned = action.luxuryItems;
        }

        if (action.mode === "AUTHENTICATED_FRONT_PAGE") {
          draft.luxuryItemsAuthenticatedFrontPage = action.luxuryItems;
        }

        break;
      }

      case CREATE_CONTACT_US_MESSAGE: {
        draft.contactUsMessageSent = true;
        draft.contactUsName = action.name;
        break;
      }

      case RETRIEVE_AUTHENTICITY: {
        const itemId = _.get(action.authenticity, "certificate_id");
        draft.authenticity[itemId] = action.authenticity;
        break;
      }

      case CREATE_CONSIGNMENT_REQUEST: {
        break;
      }

      case CREATE_REMOVE_CONSIGNMENT_REQUEST: {
        break;
      }

      case RETRIEVE_LUXURY_BRANDS: {
        draft.luxuryBrands = action.luxuryBrands;
        break;
      }

      case CREATE_SERVICE_REQUEST: {
        if (action.referenceNumber) {
          draft.orderSuccessRefNumber = action.referenceNumber;
          draft.shoppingCart = [];
        }
        break;
      }

      case ADD_TO_CART: {
        const itemsInCartId = new Set();

        draft.shoppingCart.forEach((i) => {
          itemsInCartId.add(_.get(i, "id"));
        });

        if (draft.cartHasService) {
          draft.shoppingCart = [];
          draft.cartHasService = false;
        }

        if (action.luxuryItemListing.isService) {
          draft.cartHasService = true;
          draft.shoppingCart = [];
        }
        draft.shoppingCart.push(action.luxuryItemListing);
        draft.cartShortId = nanoid(10);
        break;
      }

      case REMOVE_FROM_CART: {
        const newShoppingCart = [];
        draft.shoppingCart.forEach((i) => {
          if (_.get(i, "id") !== _.get(action.luxuryItemListing, "id")) {
            newShoppingCart.push(i);
          } else {
            if (i.isService) {
              draft.cartHasService = false;
            }
          }
        });

        draft.shoppingCart = newShoppingCart;
        draft.cartShortId = nanoid(10);
        break;
      }

      case CREATE_ORDER: {
        draft.shoppingCart = [];
        draft.cartShortId = null;
        break;
      }

      case RETRIEVE_PAYMENT_METHODS: {
        draft.paymentMethods = action.paymentMethods;
        break;
      }

      case RETRIEVE_CUSTOMER_ORDERS: {
        draft.customerOrders = action.customerOrders;
        break;
      }

      case RETRIEVE_LUXURY_ITEM_LISTING_DETAILS: {
        const listingId = _.get(action.luxuryItemListing, "id");
        draft.luxuryItemListingDetails[listingId] = action.luxuryItemListing;
        break;
      }

      case CREATE_CREDIT_CARD_ORDER: {
        draft.shoppingCart = [];
        draft.cartShortId = nanoid(10);
        draft.orderSuccessRefNumber = action.referenceNumber;
        break;
      }

      case SUBMIT_CREDIT_CARD_INFO: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const retrieveLuxuryItemListings = (
  {
    values,
    processingState,
    successState,
    errorState,
    page,
    pageSize,
    clearItems,
  },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: `luxury_listings.retrieveLuxuryItemListings.${_.get(
            values,
            "mode"
          )}`,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_RETRIEVE_ITEM_LISTINGS +
          `?page=${page}&page_size=${pageSize}`,
        values
      )
      .then((response) => {
        const luxuryItems = _.get(response, "data.luxury_item_listings", []);
        const resultCount = _.get(response, "data.result_count");
        const mode = _.get(values, "mode");

        dispatch({
          type: RETRIEVE_LUXURY_ITEM_LISTINGS,
          luxuryItems,
          resultCount,
          mode,
          clearItems,
        });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_listings.retrieveLuxuryItemListings",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_LUXURY_ITEM_LISTINGS_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "luxury_listings.retrieveLuxuryItemListings",
                },
            history
          )
        );
      });
  };
};

export const createContactUsMessage = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_listings.createContactUsMessage",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_CREATE_CONTACT_US_MESSAGE,
        values
      )
      .then((response) => {
        const name = _.get(values, "name");

        dispatch({ type: CREATE_CONTACT_US_MESSAGE, name });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_listings.createContactUsMessage",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_CONTACT_US_MESSAGE_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxury_listings.createContactUsMessage",
                  notificationType: "alert",
                },
            history
          )
        );

        // dispatch(
        //   typeof errorState === "function"
        //     ? errorState(error, values)
        //     : errorState ?? {
        //         ...error,
        //         context: "luxury_listings.createContactUsMessage",
        //         notificationType: "alert",
        //       },
        //   history
        // );
      });
  };
};

export const retrieveAuthenticity = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_listings.retrieveAuthenticity",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_RETRIEVE_AUTHENTICITY,
        values
      )
      .then((response) => {
        const authenticity = _.get(response, "data.authenticity");

        dispatch({ type: RETRIEVE_AUTHENTICITY, authenticity });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_listings.retrieveAuthenticity",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_AUTHENTICITY_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxury_listings.retrieveAuthenticity",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const createConsignmentRequest = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.createConsignmentRequest",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_CREATE_CONSIGNMENT_REQUEST,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_CONSIGNMENT_REQUEST });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_item_listings.createConsignmentRequest",
                },
            history
          )
        );

        const newValues = values;
        newValues.mode = "MY_AUTHENTICATED_BAGS";
        dispatch(retrieveLuxuryItemListings({ values: newValues }));
      })
      .catch((errorResponse) => {
        let error = CREATE_CONSIGNMENT_REQUEST_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "luxury_item_listings.createConsignmentRequest",
                },
            history
          )
        );
      });
  };
};

export const createRemoveConsignmentRequest = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.createRemoveConsignmentRequest",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_CREATE_REMOVE_CONSIGNMENT_REQUEST,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_REMOVE_CONSIGNMENT_REQUEST });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "luxury_item_listings.createRemoveConsignmentRequest",
                },
            history
          )
        );
        values.mode = "MY_CONSIGNMENTS";
        dispatch(retrieveLuxuryItemListings({ values }));
      })
      .catch((errorResponse) => {
        let error = CREATE_REMOVE_CONSIGNMENT_REQUEST_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context:
                    "luxury_item_listings.createRemoveConsignmentRequest",
                },
            history
          )
        );
      });
  };
};

export const retrieveLuxuryBrands = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.retrieveLuxuryBrands",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_RETRIEVE_LUXURY_BRANDS,
        values
      )
      .then((response) => {
        const luxuryBrands = _.get(response, "data.luxury_brands");

        dispatch({ type: RETRIEVE_LUXURY_BRANDS, luxuryBrands });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_item_listing.retrieveLuxuryBrands",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_LUXURY_BRANDS_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxury_item_listing.retrieveLuxuryBrands",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const createServiceRequest = (
  {
    values,
    selectedImages,
    processingState,
    successState,
    errorState,
    isServiceCheckout,
    creditCardToken,
    paymentShortId,
    content,
  },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.createServiceRequest",
          message: strings.lib_common_state_loading,
        }
      )
    );

    const data = new FormData();
    for (let key in values) {
      data.append(key, values[key]);
    }

    data.append(`num_item_images`, selectedImages.length);
    selectedImages.forEach((i, index) => {
      data.append(`item_image_${index}`, i);
    });

    data.append("is_service_checkout", isServiceCheckout);
    data.append("credit_card_token", _.get(creditCardToken, "data.id"));
    data.append("credit_card_type", _.get(creditCardToken, "data.type"));
    data.append("payment_short_id", paymentShortId);

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_CREATE_SERVICE_REQUEST,
        data
      )
      .then((response) => {
        const referenceNumber = _.get(response, "data.reference_number", null);

        dispatch({ type: CREATE_SERVICE_REQUEST, referenceNumber });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: isServiceCheckout
                    ? "luxury_item_listings.createCreditCardOrder"
                    : "luxury_item_listings.createServiceRequest",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_SERVICE_REQUEST_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: isServiceCheckout
                    ? "luxury_item_listings.createCreditCardOrder"
                    : "luxury_item_listings.createServiceRequest",
                },
            history
          )
        );

        if (_.get(content, "current")) {
          _.get(content, "current").scrollToTop();
        }
      });
  };
};

export const addToCart = (
  { luxuryItemListing, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADD_TO_CART,
        luxuryItemListing,
      });

      resolve();
    });
  };
};

export const removeFromCart = (
  { luxuryItemListing, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch({ type: REMOVE_FROM_CART, luxuryItemListing });
  };
};

export const createOrder = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.createOrder",
          message: strings.lib_common_state_loading,
        }
      )
    );

    const data = new FormData();
    for (let key in values) {
      data.append(key, values[key]);
    }

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_CREATE_ORDER,
        data
      )
      .then((response) => {
        dispatch({ type: CREATE_ORDER });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_item_listings.createOrder",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_ORDER_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "luxury_item_listings.createOrder",
                },
            history
          )
        );
      });
  };
};

export const retrievePaymentMethods = () => {
  return (dispatch) => {
    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_RETRIEVE_PAYMENT_METHODS
      )
      .then((response) => {
        const paymentMethods = _.get(response, "data.payment_methods");
        dispatch({ type: RETRIEVE_PAYMENT_METHODS, paymentMethods });
      })
      .catch((errorResponse) => {});
  };
};

export const retrieveCustomerOrders = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.retrieveCustomerOrders",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_RETRIEVE_ORDERS,
        values
      )
      .then((response) => {
        const customerOrders = _.get(response, "data.customer_orders", []);
        dispatch({ type: RETRIEVE_CUSTOMER_ORDERS, customerOrders });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_item_listings.retrieveCustomerOrders",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_CUSTOMER_ORDERS_ERRORS.DEFAULT;

        dispatch(
          setAppProcessing(
            typeof processingState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "luxury_item_listings.retrieveCustomerOrders",
                },
            history
          )
        );
      });
  };
};

export const retrieveLuxuryItemListingDetails = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.retrieveLuxuryItemListingDetails",
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_RETRIEVE_ITEM_LISTING_DETAILS,
        values
      )
      .then((response) => {
        const luxuryItemListing = _.get(response, "data.luxury_item_listing");
        dispatch({
          type: RETRIEVE_LUXURY_ITEM_LISTING_DETAILS,
          luxuryItemListing,
        });
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_LUXURY_ITEM_LISTING_DETAILS_ERROR.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context:
                    "luxury_item_listings.retrieveLuxuryItemListingDetails",
                },
            history
          )
        );
      });
  };
};

export const createCertificateHardCopyRequest = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.createCertificateHardCopyRequest",
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_CREATE_CERTIFICATE_HARD_COPY_REQUEST,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_CERTIFICATE_HARD_COPY_REQUEST });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "luxury_item_listings.createCertificateHardCopyRequest",
                },
            history
          )
        );
        values.mode = "MY_AUTHENTICATED_BAGS";
        dispatch(retrieveLuxuryItemListings({ values }));
      })
      .catch((errorResponse) => {
        let error = CREATE_CERTIFICATE_HARD_COPY_REQUEST_ERRORS.DEFAULT;
        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context:
                    "luxury_item_listings.createCertificateHardCopyRequest",
                },
            history
          )
        );
      });
  };
};

export const submitCreditCardInfo = (
  {
    values,
    processingState,
    successState,
    errorState,
    content,
    isServiceCheckout,
  },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.submitCreditCardInfo",
        }
      )
    );

    const createTokenEndpoint =
      process.env.REACT_APP_API_PAYMONGO_API_CREATE_TOKEN;
    const createTokenHeaders = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization:
        "Basic " + btoa(process.env.REACT_APP_API_PAYMONGO_PUBLIC_KEY + ":"),
    };
    const createTokenData = {
      data: {
        attributes: {
          billing: {
            name: _.get(values, "credit_card_details.name", ""),
            email: _.get(values, "account_email"),
          },
          number: _.get(values, "credit_card_details.number", "").replace(
            /\s+/g,
            ""
          ),
          exp_month: parseInt(
            _.get(values, "credit_card_details.expiry", "").split("/")[0]
          ),
          exp_year: parseInt(
            _.get(values, "credit_card_details.expiry", "").split("/")[1]
          ),
          cvc: _.get(values, "credit_card_details.cvc", ""),
        },
      },
    };

    axios
      .post(createTokenEndpoint, createTokenData, {
        headers: createTokenHeaders,
      })
      .then((response) => {
        dispatch({ type: SUBMIT_CREDIT_CARD_INFO });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_item_listings.submitCreditCardInfo",
                },
            history
          )
        );

        if (!isServiceCheckout) {
          dispatch(
            createCreditCardOrder({
              creditCardToken: response.data,
              authToken: values.auth_token,
              orderItemIds: values.order_item_ids,
              paymentShortId: values.payment_short_id,
              processingState,
              successState,
              errorState,
              content,
            })
          );
        } else {
          let serviceItem = _.get(values, "service_item");
          let serviceItemValues = _.get(serviceItem, "values");

          dispatch(
            createServiceRequest({
              values: serviceItemValues,
              selectedImages: _.get(serviceItem, "selectedImages"),
              isServiceCheckout: isServiceCheckout,
              creditCardToken: response.data,
              paymentShortId: values.payment_short_id,
              content,
            })
          );
        }
      })
      .catch((errorResponse) => {
        let error = SUBMIT_CREDIT_CARD_INFO_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "luxury_item_listings.submitCreditCardInfo",
                },
            history
          )
        );

        if (_.get(content, "current")) {
          _.get(content, "current").scrollToTop();
        }
      });
  };
};

export const createCreditCardOrder = (
  {
    creditCardToken,
    authToken,
    orderItemIds,
    paymentShortId,
    processingState,
    successState,
    errorState,
    content,
  },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_item_listings.createCreditCardOrder",
        }
      )
    );

    const values = {
      auth_token: authToken,
      credit_card_token: creditCardToken,
      order_item_ids: orderItemIds,
      payment_short_id: paymentShortId,
    };

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_CREATE_CREDIT_CARD_ORDER,
        values
      )
      .then((response) => {
        const referenceNumber = _.get(response, "data.reference_number");
        dispatch({ type: CREATE_CREDIT_CARD_ORDER, referenceNumber });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_item_listings.createCreditCardOrder",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_CREDIT_CARD_ORDER_ERROS.DEFAULT;
        dispatch(
          setAppError(
            typeof errorState == "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "luxury_item_listings.createCreditCardOrder",
                },
            history
          )
        );

        if (_.get(content, "current")) {
          _.get(content, "current").scrollToTop();
        }
      });
  };
};
